export const calculateSelectedFilterOperation = operation => {
	switch (operation) {
		case 'contains':
			return 'contains';
		case 'equal':
			return '=';
		case 'greaterThan':
			return '>';
		case 'graterThenOrEqual':
			return '>=';
		case 'lessThan':
			return '<';
		case 'lessThanOrEqual':
			return '<=';
		case 'notContains':
			return 'notcontains';
		case 'startsWith':
			return 'startswith';
		case 'endsWith':
			return 'endswith';
		case 'notEqual':
			return '<>';
	}
};
